var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMicrosoft = function SvgMicrosoft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#microsoft_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F35325",
    d: "M2 2h9.524v9.524H2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#81BC06",
    d: "M12.476 2H22v9.524h-9.524z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#05A6F0",
    d: "M2 12.476h9.524V22H2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFBA08",
    d: "M12.476 12.476H22V22h-9.524z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "microsoft_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2 2h20v20H2z"
  })))));
};
export default SvgMicrosoft;